import * as React from 'react';
import { Query } from 'react-apollo';

import PendingMembershipsButton from 'groupMembershipRequests/components/PendingMembershipsButton';

// @ts-ignore
import GROUP_MEMBERSHIP_REQUESTS_BUTTON_QUERY from './queries/GroupMembershipRequestsButtonQuery.gql';

import {
  GroupMembershipRequestsButtonQuery,
  GroupMembershipRequestsButtonQueryVariables,
  GroupMembershipRequestsButtonQuery_classes,
} from './queries/__generated__/GroupMembershipRequestsButtonQuery';

import { findMatchingRecord } from 'utils/arrayHelpers';

type Props = {
  groupUuid: string;
  groupName: string;
};

class PendingMembershipsButtonContainer extends React.Component<Props> {
  render() {
    const { groupName, groupUuid } = this.props;

    return (
      <Query<GroupMembershipRequestsButtonQuery, GroupMembershipRequestsButtonQueryVariables>
        query={GROUP_MEMBERSHIP_REQUESTS_BUTTON_QUERY}
        variables={{ groupUuid }}
        fetchPolicy="network-only">
        {({ data, error, loading }) => {
          if (loading || !data) {
            return null;
          }

          const group = findMatchingRecord<GroupMembershipRequestsButtonQuery_classes>(
            data.classes,
            groupUuid
          );

          if (!group) {
            return null;
          }

          const { groupMembershipRequestsCount, requestToJoinEnabled } = group;

          if (requestToJoinEnabled) {
            return (
              <PendingMembershipsButton
                data-test="pending-memberships-btn"
                groupMembershipRequestsCount={groupMembershipRequestsCount}
                groupName={groupName}
              />
            );
          }

          return null;
        }}
      </Query>
    );
  }
}

export default PendingMembershipsButtonContainer;
